import { useCallback, useState } from 'react';
import { CODE_LANGUAGES, CodeLanguage } from './snippets';

const STORAGE_KEY = 'preferredCodeLanguage';
const DEFAULT_LANGUAGE: CodeLanguage = 'python';

const isCodeLanguage = (value: unknown): value is CodeLanguage =>
  typeof value === 'string' &&
  (CODE_LANGUAGES as readonly string[]).includes(value);

const readStoredLanguage = (): CodeLanguage => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return isCodeLanguage(stored) ? stored : DEFAULT_LANGUAGE;
  } catch {
    return DEFAULT_LANGUAGE;
  }
};

export const usePreferredCodeLanguage = (): [
  CodeLanguage,
  (language: CodeLanguage) => void,
] => {
  const [language, setLanguageState] =
    useState<CodeLanguage>(readStoredLanguage);

  const setLanguage = useCallback((next: CodeLanguage) => {
    setLanguageState(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // localStorage can throw in private mode or when full; preference simply won't persist.
    }
  }, []);

  return [language, setLanguage];
};
